var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2512 21.8908C16.5652 22.1611 17.0387 22.1257 17.309 21.8118C17.5792 21.4979 17.5438 21.0243 17.2299 20.7541L16.2512 21.8908ZM6.49988 12.5059L6.00598 13.0703L6.01054 13.0742L6.49988 12.5059ZM6.49988 11.7533L6.99376 12.3177L6.9944 12.3172L6.49988 11.7533ZM17.2351 3.33609C17.5465 3.06298 17.5776 2.58912 17.3045 2.2777C17.0313 1.96628 16.5575 1.93523 16.2461 2.20834L17.2351 3.33609ZM17.2299 20.7541L6.98921 11.9375L6.01054 13.0742L16.2512 21.8908L17.2299 20.7541ZM6.9944 12.3172L17.2351 3.33609L16.2461 2.20834L6.00537 11.1894L6.9944 12.3172ZM6.99376 11.9414C7.10759 12.041 7.10759 12.2181 6.99376 12.3177L6.006 11.1889C5.43684 11.6869 5.43684 12.5723 6.006 13.0703L6.99376 11.9414Z",
    fill: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.e21bd0bb44fec6d708aeeede360ba825.svg";
export { ForwardRef as ReactComponent };